import {useSearchParams} from 'react-router-dom';
import {useEffect, useRef} from 'react';
import {apiClient} from '../../../http/query-client';
import {toast} from '../../../ui/toast/toast';
import {message} from '../../../i18n/message';
import {useNavigate} from 'react-router-dom';
import { useBootstrapData } from '@common/core/bootstrap-data/bootstrap-data-context';
import { invalidateBootstrapData } from '@common/core/bootstrap-data/use-backend-bootstrap-data';
import {setTrackingParametersCookie} from '@common/utils/hooks/use-tracking-parameters';

export function useZainSdRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const {data} = useBootstrapData();
  const logSentRef = useRef(false);

  useEffect(() => {
    const msisdn = searchParams.get('msisdn');
    const productCode = data.environment.DEFAULT_REDIRECT_PRODUCT_CODE;
    const trackingParameters = Object.fromEntries(searchParams.entries());
    const hasTrackingParams = Object.keys(trackingParameters).length > 0;
    const conversionUrl = data?.environment?.CONVERSION_URL;
    const conversionLoggerUrl = conversionUrl
      ? conversionUrl.endsWith('/')
        ? `${conversionUrl}logger`
        : `${conversionUrl}/logger`
      : undefined;
    

    console.log("🚀🚀🚀 ~ use-zain-sd-redirect.tsx:23 ~ useZainSdRedirect ~ msisdn:", msisdn)

    if (msisdn) {
      if (hasTrackingParams && searchParams.get('gclid')) {
        setTrackingParametersCookie(trackingParameters);
      }
      if (conversionLoggerUrl && !logSentRef.current) {
        logSentRef.current = true;
        const allParams = Object.fromEntries(searchParams.entries());
        fetch(conversionLoggerUrl, {
          method: 'POST',
          body: JSON.stringify(allParams),
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }
      // Clear the query parameters
      navigate('/', {replace: true});
      
      // Sync with backend
      apiClient
        .post('billing/zain-sd/sync-subscription-details', {
          phone: msisdn,
          product_code: productCode,
          tracking_parameters: hasTrackingParams ? trackingParameters : undefined,
        })
        .then(response => {
          if (response.data.subscription) {
            toast(message('Subscription activated successfully'));
            invalidateBootstrapData();
          }
        })
        .catch(err => {
          // Error handling similar to other gateways
          console.log("🚀 ~ file: use-zain-sd-redirect.tsx:43 ~ useEffect ~ err:", err);
          if (err?.response?.data?.error?.message) {
            toast.danger(err.response.data.error.message);
          }
        });
    }
  }, [
    data.environment.DEFAULT_REDIRECT_PRODUCT_CODE,
    data?.environment?.CONVERSION_URL,
    navigate,
    searchParams,
  ]);

  return null;
} 